import ReactDOm from "react-dom/client"
import Counter from "./counter"
const root=ReactDOm.createRoot(document.getElementById("root"))
root.render(<>
<Counter/>
</>)